export const CREATE_STATEMENT_TEMPLATE_FAILURE = 'CREATE_STATEMENT_TEMPLATE_FAILURE';

export const createStatementTemplateFailure = error => ({
    type: CREATE_STATEMENT_TEMPLATE_FAILURE,
    payload: error,
    error: true,
});
